import { render, staticRenderFns } from "./PriceAdd.vue?vue&type=template&id=1c1b82ee"
import script from "./PriceAdd.vue?vue&type=script&lang=js"
export * from "./PriceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports